/* eslint-disable */

export class SWHREF {
	static init(elem) {
		$(elem)
			.find('[data-swhref]')
			.click(function () {
				let $link = $(this),
					rnd = Math.floor(Math.random() * 100000000),
					target = typeof $link.data('swtarget') != 'undefined' && $link.data('swtarget') !== '' ? $link.data('swtarget') : '_self',
					url = $link.data('swhref');
				if (target == '_self') {
					window.location.href = url;
				} else {
					window.open(url, target);
				}
			});
	}
}
